module.exports = __webpack_public_path__ + "static/media/iconSupermarked.12428fed.png";